<template>
  <CContainer>
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CRow class="tardy-module-header-row flex-wrap gy-2">
          <CCol class="d-flex min-w-0 col-12 col-md-6 align-items-center">
            <div class="v3-module-list-title" role="heading" aria-level="2">
              Tardy Management
            </div>
            <HelpCenterButton
              classes="ms-2"
              content-key="module_tardy_management"
            />

            <BaseButton class="ms-2 danger" rounded @click="clearModuleData">
              Clear Data
            </BaseButton>
            <p class="text-muted ms-2 mb-0" v-if="getLastResetInfo">
              Last run:
              {{
                helpers.convertUTCToLocalTime(
                  getLastResetInfo.run_at,
                  null,
                  "MM/DD hh:mm A"
                )
              }}
            </p>
          </CCol>
          <CCol
            class="d-flex flex-row-reverse align-items-center col-12 col-md-6"
          >
            <CustomSwitch
              type="radio"
              aria-label="Tardy Management, toggle module on or off"
              :model-value="state.isActive"
              @change="toggleTardy(state.isActive)"
            ></CustomSwitch>
          </CCol>
        </CRow>
        <div class="v3-module-list-box" v-if="state.isActive">
          <div>
            <p class="mb-3">TCH Pass:</p>

            <div class="v3-module-list-checkbox d-flex ms-3 mb-3">
              <CustomCheck
                v-model="state.form.usageEHP"
                label="Allow Admins"
                @change="submit"
              ></CustomCheck>
            </div>

            <div class="v3-module-list-checkbox d-flex ms-3 mb-3">
              <CustomCheck
                v-if="state.form.usageEHP"
                v-model="state.form.allowTeacherStaff"
                label="Allow all teachers/staff"
                @change="allowTeacherStaff"
              ></CustomCheck>
            </div>

            <div class="v3-module-list-checkbox d-flex ms-3 mb-3">
              <CustomCheck
                v-if="state.form.usageEHP"
                v-model="state.form.allowSelectedUsersOnly"
                label="Only allow specific teachers/staff"
                @change="allowSelectedUsersOnly"
              ></CustomCheck>
            </div>
            <BaseButton
              v-if="state.form.allowSelectedUsersOnly && state.form.usageEHP"
              class="mb-4"
              @click="goToSelectAdultsPage"
              rounded
              >Add Adults</BaseButton
            >

            <p v-if="state.form.usageEHP" class="mb-2 text-start">
              Student Options:
            </p>

            <div
              v-if="state.form.usageEHP"
              class="d-flex tardy-module-student-options flex-wrap align-items-start"
            >
              <p class="text-start align-items-center mb-0">
                Allow Students to mark:
              </p>
              <div class="v3-module-list-checkbox ms-2">
                <CustomCheck
                  v-if="state.form.usageEHP"
                  v-model="state.form.allowStudentsLTC"
                  label="LTC"
                  @change="allowStudentsLTC"
                ></CustomCheck>
              </div>

              <div class="v3-module-list-checkbox ms-2">
                <CustomCheck
                  v-if="state.form.usageEHP"
                  v-model="state.form.allowStudentsLTS"
                  label="LTS"
                  @change="allowStudentsLTS"
                ></CustomCheck>
              </div>
              <p
                class="text-start ms-3 mb-0 tardy-module-student-options__ladder-label"
              >
                Allow students to see ladder:
              </p>

              <div class="v3-module-list-checkbox ms-2">
                <CustomCheck
                  v-model="state.form.allowStudentsSeeLevel"
                  input-aria-label="Allow students to see ladder"
                  @change="submit"
                ></CustomCheck>
              </div>
            </div>

            <div
              class="d-flex tardy-module-student-options flex-wrap align-items-start mt-3"
            >
              <p
                class="col d-flex min-w-0 col-12 col-md-6 text-start align-items-center mb-0"
              >
                Count SLP as a pass against a student pass limit
              </p>
              <div
                class="col d-flex flex-row-reverse align-items-center col-12 col-md-6"
              >
                <CustomSwitch
                  aria-label="Count SLP as a pass against a student pass limit"
                  :model-value="state.slpCount"
                  @change="toggleSLPCount"
                ></CustomSwitch>
              </div>
            </div>
          </div>
        </div>
        <CAlert
          v-if="state.reqResponse.message"
          dismissible
          class="mt-4"
          :color="state.reqResponse.type"
          :show="!!state.reqResponse.message"
          role="status"
          aria-live="polite"
          @close="resetResponseMessages"
        >
          {{ state.reqResponse.message }}
        </CAlert>
      </CCol>
    </CRow>
  </CContainer>
</template>
<script>
import HelpCenterButton from "../../HelpCenterButton.vue"
import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"
import CustomCheck from "@/v3components/shared/Form/CustomCheck.vue"
import CustomSwitch from "@/v3components/shared/Form/CustomSwitch.vue"
import { useStore } from "vuex"
import { onMounted, computed, reactive, ref, inject } from "vue"
import { useRouter } from "vue-router"
import helpers from "@/helpers"
import passConstants from "@/constants/passConstants"

export default {
  name: "TardyManagementModuleForm",
  components: {
    HelpCenterButton,
    BaseButton,
    CustomCheck,
    CustomSwitch
  },
  setup() {
    const store = useStore()
    const actionDialog = inject("actionDialog")
    const router = useRouter()

    const state = reactive({
      form: {
        allowTeacherStaff: false,
        allowSelectedUsersOnly: false,
        allowStudentsLTC: false,
        allowStudentsLTS: false,
        allowStudentsSeeLevel: false,
        usageCSV: false,
        usageEHP: false,
        fileUploadMode: passConstants.DEFAULT_FILE_UPLOAD_MODE_FOR_TARDY
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      isActive: false,
      slpCount: false
    })

    const isLoading = ref(false)

    const schoolDomains = computed(() => store.getters["schools/schoolDomains"])
    const currentUser = computed(() => store.getters["authentication/user"])

    const options = computed(() => {
      const tardyModule = store.state.schools.activeSchoolModules.find(
        (module) => module.name === "Tardy Management"
      )
      return tardyModule ? JSON.parse(tardyModule.pivot.option_json) : false
    })

    const active = computed(() => {
      const tardyModule = store.state.schools.activeSchoolModules.find(
        (module) => module.name === "Tardy Management"
      )
      return tardyModule ? Boolean(tardyModule.pivot.status) : false
    })
    onMounted(() => {
      if (options.value) {
        setForm()
      }
      state.isActive = active.value
    })

    const setForm = () => {
      state.form.allowTeacherStaff = options.value["allow-teacher-staff"]
      state.form.allowSelectedUsersOnly =
        options.value["allow-selected-users-only"]
      state.form.allowStudentsLTS =
        options.value["allow-students-create"]["lts"]
      state.form.allowStudentsLTC =
        options.value["allow-students-create"]["ltc"]
      state.form.allowStudentsSeeLevel =
        options.value["allow-students-see-level"]
      state.form.usageCSV = options.value.usage["via-csv"]
      state.form.usageEHP = options.value.usage["within-ehp"]
      state.form.fileUploadMode =
        options?.value?.["file-upload-mode"] ||
        passConstants.DEFAULT_FILE_UPLOAD_MODE_FOR_TARDY
      state.slpCount = Boolean(options.value?.["count-slp-against-pass-limit"])
    }
    const getLastResetInfo = computed(() => {
      const lastResetInfo = options.value?.reset_history ?? []
      return lastResetInfo.length > 0
        ? lastResetInfo[lastResetInfo.length - 1]
        : null
    })

    const allowTeacherStaff = (value) => {
      state.form.allowTeacherStaff = value
      if (value == true) {
        state.form.allowSelectedUsersOnly = false
        submit()
      } else {
        submit()
      }
    }

    const allowStudentsLTC = (value) => {
      state.form.allowStudentsLTC = value
      if (value == true) {
        state.form.allowSelectedUsersOnly = false
        submit()
      } else {
        submit()
      }
    }

    const allowStudentsLTS = (value) => {
      state.form.allowStudentsLTS = value
      if (value == true) {
        state.form.allowSelectedUsersOnly = false
        submit()
      } else {
        submit()
      }
    }

    const allowSelectedUsersOnly = (value) => {
      state.form.allowSelectedUsersOnly = value
      if (value == true) {
        state.form.allowTeacherStaff = false
        state.form.allowStudents = false
        submit()
      } else {
        submit()
      }
    }

    const submit = () => {
      setTimeout(() => {
        resetResponseMessages()
        const inputsData = JSON.stringify({
          "allow-teacher-staff": state.form.allowTeacherStaff,
          "allow-selected-users-only": state.form.allowSelectedUsersOnly,
          "allow-students-create": {
            ltc: state.form.allowStudentsLTC,
            lts: state.form.allowStudentsLTS
          },
          "allow-students-see-level": state.form.allowStudentsSeeLevel,
          "file-upload-mode": state.form.fileUploadMode,
          "count-slp-against-pass-limit": state.slpCount,
          usage: {
            "via-csv": state.form.usageCSV,
            "within-ehp": state.form.usageEHP
          }
        })
        isLoading.value = true
        store
          .dispatch("modules/updateTardyModule", { option_json: inputsData })
          .then(() => {
            setSuccessResponse("Module updated.")
            store
              .dispatch("schools/getActiveModules", {
                clearCacheEntry: true
              })
              .then(() => {
                setForm()
              })
            isLoading.value = false
          })
          .catch((err) => {
            const response = err.response.data
            setErrorResponse(response.message, response.errors)
            isLoading.value = false
            store
              .dispatch("schools/getActiveModules", {
                clearCacheEntry: true
              })
              .then(() => {
                setForm()
              })
          })
      }, 100)
    }

    const toggleTardy = (status) => {
      store
        .dispatch("modules/toggleModule", {
          id: 5,
          moduleStatus: { status: status ? 0 : 1 }
        })
        .then(() => {
          state.isActive = !state.isActive
          store
            .dispatch("schools/getActiveModules", {
              clearCacheEntry: true
            })
            .then(() => {
              getExceededIncidents()
            })
        })
    }

    const toggleSLPCount = (value) => {
      state.slpCount = Boolean(value)
      submit()
    }

    const getExceededIncidents = () => {
      state.isActive
        ? store.dispatch("exceededIncidents/getExceededIncidents")
        : store.commit("exceededIncidents/SET_EXCEEDED_INCIDENTS", false)
    }

    const goToSelectAdultsPage = () => {
      router.push("/tardy-management/adults")
    }

    const clearModuleData = () => {
      actionDialog.open(clearModule, {
        props: {
          danger: true,
          title: "Clear Tardy Management Module data?",
          question:
            "This action will clear all the data for the Tardy Management Module. \n\n[Tardy Uploads, Tardy Detentions and Calendar, Consequences Ladder, Tardy Ladder Reset Date]"
        }
      })
    }

    const clearModule = () => {
      store.dispatch("modules/clearTardyModuleData").then(() => {
        setSuccessResponse("Tardy Management Module data cleared.")
        state.isActive = false
        store
          .dispatch("schools/getActiveModules", {
            clearCacheEntry: true
          })
          .then(() => {
            setForm()
          })
      })
    }

    const resetResponseMessages = () => {
      state.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    }

    const setSuccessResponse = (message) => {
      state.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    }
    return {
      state,
      schoolDomains,
      currentUser,
      setForm,
      allowTeacherStaff,
      allowStudentsLTC,
      allowStudentsLTS,
      allowSelectedUsersOnly,
      submit,
      toggleTardy,
      goToSelectAdultsPage,
      toggleSLPCount,
      resetResponseMessages,
      clearModuleData,
      getLastResetInfo,
      helpers
    }
  }
}
</script>
